<template>
  <footer>
    <div class="footer">
      <img v-on:click="pager.toggleDebug()" class="footer_logo" src="@/assets/footerlogo.svg" />
      <ul class="footer_link">
        <li class="footer_link__item">
          <a class="footer_link__item_link" :href="companyurl()">運営会社</a>
        </li>
        <li class="footer_link__item">
          <a class="footer_link__item_link" :href="termsurl()">利用規約</a>
        </li>
        <li class="footer_link__item">
          <a class="footer_link__item_link" :href="policyurl()">個人情報保護方針</a>
        </li>
        <li class="footer_link__item">
          <a class="footer_link__item_link" href="mailto:hello@fitgap.com">お問い合わせ</a>
        </li>
      </ul>
      <div class="contact_us" v-on:click="contactus">
        <div class="contact_us__icon"><img width="24" height="24" src="@/assets/message.svg" /></div>
        <div class="contact_us__title">ご意見・ご要望</div>
      </div>
    </div>
    <p class="footer_copyright">
      <small v-if="pager.isDebug" style="color: #f00">デバグモード</small>
      <small>© 2022 PIGNUS Inc.</small>
    </p>
  </footer>
</template>

<style scoped>
.footer {
  position: relative;
}

.contact_us_layer {
  position: fixed;
  bottom: 20px;
  right: 20px;
  z-index: 3;
}

.contact_us {
  padding: 13px;
  display: flex;
  box-shadow: 0px 0px 2px 0px #0000003D;
  border-radius: 20px;
  background: white;
  z-index: 3;
  cursor: pointer;
  position: absolute;
  top: -12px;
  left: 520px;
}

.contact_us:hover {
  border: 1px solid #444545;
}

.contact_us__icon {
  position: absolute;
  top: 10px;
}

.contact_us__title {
  font-family: Noto Sans JP;
  font-size: 14px;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: center;
  margin-left: 35px;
}

@media screen and (max-width: 760px) {
  .contact_us {
    display: none;
  }
}
</style>

<script>
export default {
  name: "ContentsFooter",
  props: {
    pager: Object,
  },
  methods: {
    companyurl() {
      return process.env.VUE_APP_SELF + "/#/company";
    },
    termsurl() {
      return process.env.VUE_APP_SELF + "/#/terms";
    },
    policyurl() {
      return process.env.VUE_APP_SELF + "/#/policy";
    },
    contactus() {
      window.open('https://docs.google.com/forms/d/e/1FAIpQLScK7dLugUzQ8gQ9BPXCLqvN23xEjrTJ2EdfJ5ySr9OBS3KGGQ/viewform', '_blank');
    }
  }
};
</script>
